import {
  BUILD_CUSTOM_TABLE_CONFIG,
  RESTORE_SINGLE_CONFIG_TABLE,
  START_REQUEST_SEARCH,
  STOP_REQUEST_SEARCH,
  BUILD_COMP_LOADINGS_SEARCH,
  BUILD_TABLE_CONFIG,
  SET_CONFIG_TABLE_PAGE_SIZE,
  SET_CONFIG_TABLE_PAGE,
  SET_CONFIG_TABLE_SORT,
  SET_CONFIG_TABLE_FILTER,
  DESTROY_CONFIG_TABLES,
  START_REQUEST_COMP_SEARCH,
  STOP_REQUEST_COMP_SEARCH,
  SET_SNACKBAR_SEARCH,
  CLEAR_SNACKBAR_SEARCH,
  REMOVE_SNACKBAR_SEARCH,
  CHANGE_STATIONS_SEARCH,
  CHANGE_UNITS_SEARCH,
  CHANGE_DIFF_SEARCH,
  CHANGE_START_DATE_SEARCH,
  CHANGE_END_DATE_SEARCH,
  CLEAR_SEARCH
} from "redux/reducers/search/searchReducer";

export const startRequest = () => {
  return {
    type: START_REQUEST_SEARCH,
  };
};

export const stopRequest = () => {
  return {
    type: STOP_REQUEST_SEARCH,
  };
};

export const buildTableConfig = (name, pageSize) => {
  return {
    type: BUILD_TABLE_CONFIG,
    payload: { name, pageSize }
  };
};

export const buildCustomTableConfig = (table, tableConfig) => {
  return {
    type: BUILD_CUSTOM_TABLE_CONFIG,
    payload: { table, tableConfig }
  };
};

export const tableConfigPageSize = (pageSize, table) => {
  return {
    type: SET_CONFIG_TABLE_PAGE_SIZE,
    payload: { pageSize, table },
  };
};
export const tableConfigPage = (page, table) => {
  return {
    type: SET_CONFIG_TABLE_PAGE,
    payload: { page, table },
  };
};
export const tableConfigSort = (sorted, table) => {
  return {
    type: SET_CONFIG_TABLE_SORT,
    payload: { sorted, table },
  };
};
export const tableConfigFilter = (filtered, table) => {
  return {
    type: SET_CONFIG_TABLE_FILTER,
    payload: { filtered, table },
  };
};
export const restoreSingleConfigTable = (table = "") => {
  return {
    type: RESTORE_SINGLE_CONFIG_TABLE,
    payload: table,
  };
};
export const destroyTableConfigs = () => {
  return {
    type: DESTROY_CONFIG_TABLES,
  };
};
export const buildCompLoadings = arrayNames => {
  return {
    type: BUILD_COMP_LOADINGS_SEARCH,
    payload: arrayNames,
  };
};

export const startRequestComp = loadingName => {
  return {
    type: START_REQUEST_COMP_SEARCH,
    payload: loadingName,
  };
};

export const stopRequestComp = loadingName => {
  return {
    type: STOP_REQUEST_COMP_SEARCH,
    payload: loadingName,
  };
};

export const setSnackbar = (message, color = "danger", position = "tr") => {
  return {
    type: SET_SNACKBAR_SEARCH,
    payload: { message, color, position }
  };
};

export const clearSnackbar = () => {
  return {
    type: CLEAR_SNACKBAR_SEARCH
  };
};

export const removeSnackbar = (id) => {
  return {
    type: REMOVE_SNACKBAR_SEARCH,
    payload: id
  };
};

export const changeStations = station => {
  return {
    type: CHANGE_STATIONS_SEARCH,
    payload: station
  };
};

export const changeUnits = unit => {
  return {
    type: CHANGE_UNITS_SEARCH,
    payload: unit
  };
};

export const changeDiff = diff => {
  return {
    type: CHANGE_DIFF_SEARCH,
    payload: diff
  };
};

export const changeStartDate = startDate => {
  return {
    type: CHANGE_START_DATE_SEARCH,
    payload: startDate
  };
};

export const changeEndDate = endDate => {
  return {
    type: CHANGE_END_DATE_SEARCH,
    payload: endDate
  };
};

export const clearSearch = () => {
  return {
    type: CLEAR_SEARCH
  };
};
